export const DEPOSIT_AMOUNT_KEY = 'fabric:registration:depositAmount';
export const TRUSTLY_COMPLETED_KEY = 'fabric:registration:trustlyCompleted';
export const PIQ_SESSION_TOKEN_KEY = 'fabric:registration:piqSessionToken';
export const PNP_COMPLETE_TYPE = 'pnp:complete';
export const PNP_CANCELED_TYPE = 'pnp:canceled';

export const PNP_ACTIONS = Object.freeze({
  LOGIN:    'login',
  REGISTER: 'register',
});

export type PnpAction = typeof PNP_ACTIONS[keyof typeof PNP_ACTIONS];

export const parsePnpAction = (value?: unknown): PnpAction =>
  typeof value === 'string' && value.toLowerCase() === PNP_ACTIONS.LOGIN
    ? PNP_ACTIONS.LOGIN
    : PNP_ACTIONS.REGISTER;

export type ParsedErrCode = {
  code: string;
  availableAmount?: string;
};

const MAX_DECIMALS = 2;

const capDecimals = (amount?: string): string | undefined => {
  if (!amount) return amount;

  const match = amount.match(/^(\d+)([.,])(\d+)$/);
  if (!match) return amount;

  const [, whole, separator, decimals] = match;
  if (decimals.length <= MAX_DECIMALS) return amount;

  return `${whole}${separator}${decimals.slice(0, MAX_DECIMALS)}`;
};

export const parseErrCode = (errCode?: unknown): ParsedErrCode => {
  const raw = String(errCode ?? '').trim().replace(/^errCode=/i, '');
  const code = raw.replace(/\[.*?\]/g, '').trim();
  const availableAmount =
    raw.match(/\[[^\]]*\ballowed\s*=\s*(\d+(?:[.,]\d+)?)/i)?.[1]
    ?? raw.match(/\[[^\]]*?(\d+(?:[.,]\d+)?)[^\]]*\]/)?.[1];

  return { code, availableAmount: capDecimals(availableAmount) };
};

export const getDepositAmount = (): string | null =>
  sessionStorage.getItem(DEPOSIT_AMOUNT_KEY)
  || localStorage.getItem(DEPOSIT_AMOUNT_KEY);

/**
 * Checks if Trustly PnP has already been completed (e.g. user returned from redirect).
 */
export const isTrustlyCompleted = (): boolean =>
  sessionStorage.getItem(TRUSTLY_COMPLETED_KEY) === 'true';

export const clearPnpSessionStorage = () => {
  sessionStorage.removeItem(TRUSTLY_COMPLETED_KEY);
  sessionStorage.removeItem(PIQ_SESSION_TOKEN_KEY);
  sessionStorage.removeItem(DEPOSIT_AMOUNT_KEY);
};
